import { render, staticRenderFns } from "./basePagination.vue?vue&type=template&id=0c145349&scoped=true"
import script from "./basePagination.vue?vue&type=script&lang=js"
export * from "./basePagination.vue?vue&type=script&lang=js"
import style0 from "./basePagination.vue?vue&type=style&index=0&id=0c145349&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c145349",
  null
  
)

export default component.exports